import React from 'react';
import style from './BlogsCard.module.scss';

const BlogsCard = (props) => {
    const { id,blogImage, blogName, blogDetails,blogWebsite } = props.blog;
    return (
      <div className="col-md-4 my-3">
        <div className="">
        <div className="">
            <img src={blogImage} />
          
        </div>
      </div>

      <div className="">
        <div className={`${style.projectCard}`}>
          <div className="">
            <h3 className='mb-4'>{blogName}</h3>
            
            <div className="technology mb-2">
              <h5>For Learning :</h5> 
              
            </div>
          </div>
          <div className="">
            <a href={blogWebsite} type='button' className='btn btn-sm btn-custom me-3 mb-2' rel="noreferrer" target="_blank">
              <small> Website</small>
            </a> 
           
          </div>
        </div>
      </div>
      
    </div>
    );
};

export default BlogsCard;